<template>
  <DocumentFormSection id="operational-title" :required="true" :show-description="false" :slot-max-width="1000">
    <OptionNameTranslationEdit
      :model-value="translationName"
      :commercial-name="curationName"
      :offer-title="undefined"
      :language="language"
      readonly
    />
  </DocumentFormSection>

  <DocumentFormSection
    v-if="translationOptionNames.length > 0"
    id="operational-option-names"
    class="bg-neutral-30 p-4 border border-neutral-60 rounded-md"
    :required="true"
    :show-description="false"
    :slot-max-width="1000"
  >
    <div v-for="(option, index) in translationOptionNames" :key="option.option_id" class="mt-4 first:mt-0">
      <OptionNameTranslationEdit
        :model-value="option.name || ''"
        class="w-full"
        :commercial-name="curationOptionNames[index]?.name || ''"
        :offer-title="undefined"
        :language="language"
        readonly
      />
    </div>
  </DocumentFormSection>
</template>

<script setup lang="ts">
import { computed } from "vue";
import DocumentFormSection from "@/components/Document/FormSection/FormSection.vue";
import OptionNameTranslationEdit from "@/features/experience-curation/option-names/components/OptionNameTranslationEdit.vue";
import { RevisionFormProps } from "../types/forms";

const props = defineProps<RevisionFormProps & { curationValues?: Record<string, any> | null }>();
const route = useRoute();

const language = computed(() => route.params.language as string);

const operationalId = computed(() => {
  const form = route.params.form as string;
  return form.replace("operational-", "");
});

const operationalTranslation = computed(() =>
  props.values?.operationalTranslations?.find((ot) => ot.operational_id === operationalId.value)
);

const curationOperationalTranslation = computed(() =>
  props.curationValues?.operationalTranslations?.find(
    (ot: { operational_id: string }) => ot.operational_id === operationalId.value
  )
);

const translationName = computed(() => operationalTranslation.value?.name || "");
const curationName = computed(() => curationOperationalTranslation.value?.name || "");

const translationOptionNames = computed(() =>
  (props.values?.optionNames ?? []).filter((opt) => opt.operational_id === operationalId.value)
);

const curationOptionNames = computed(() =>
  (props.curationValues?.optionNames ?? []).filter(
    (opt: { operational_id?: string }) => opt.operational_id === operationalId.value
  )
);
</script>
